(function() {
  const initializedContainers = new WeakSet();

  function initCacheForContainer(container) {
    if (initializedContainers.has(container)) return;
    initializedContainers.add(container);


    let cacheCanvas = document.createElement('canvas');
    cacheCanvas.className = 'cpb-shadow-cache';
    cacheCanvas.style.cssText = 'position: absolute; top: 0; left: 0; pointer-events: none; padding: 0px; margin: 0px; border: 0px; background: transparent; z-index: -1; display: block;';
    
    container.insertBefore(cacheCanvas, container.firstChild);
    const ctx = cacheCanvas.getContext('2d', { willReadFrequently: true });

    function syncPixels() {

      if (!cacheCanvas.parentNode) {
        container.insertBefore(cacheCanvas, container.firstChild);
      }

      const konvaCanvases = container.querySelectorAll('canvas:not(.cpb-shadow-cache)');
      const validCanvas = Array.from(konvaCanvases).find(c => c.width > 0);

      if (validCanvas) {
        if (cacheCanvas.width !== validCanvas.width || cacheCanvas.height !== validCanvas.height) {
          cacheCanvas.width = validCanvas.width;
          cacheCanvas.height = validCanvas.height;
        }
        cacheCanvas.style.width = validCanvas.style.width;
        cacheCanvas.style.height = validCanvas.style.height;

        ctx.clearRect(0, 0, cacheCanvas.width, cacheCanvas.height);
        konvaCanvases.forEach(c => {
          if (c.width > 0 && c.height > 0) {
            ctx.drawImage(c, 0, 0);
          }
        });
      }

      requestAnimationFrame(syncPixels);
    }

    requestAnimationFrame(syncPixels);
  }

  function observeNewContainers() {
    const globalObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) {
              if (node.classList && node.classList.contains('konvajs-content')) {
                initCacheForContainer(node);
              } else if (node.querySelectorAll) {
                const nested = node.querySelectorAll('.konvajs-content');
                nested.forEach(initCacheForContainer);
              }
            }
          });
        }
      });
    });
    globalObserver.observe(document.body, { childList: true, subtree: true });
  }

  function initVisualCache() {
    document.querySelectorAll('.konvajs-content').forEach(initCacheForContainer);
    observeNewContainers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVisualCache);
  } else {
    initVisualCache();
  }
})();

const moveTitleAndDiscrOnMobile = () => {
  const buidler = document.querySelector('#product-builder');
  const previewAside = buidler.querySelector('.cpb-preview-aside');
  const productTitle = buidler.querySelector('.cpb-product-title');
  const productDiscr = buidler.querySelector('.cpb-product-description');
  const panelsContainer = buidler.querySelector('.cpb-panels-container');
  const productActions = buidler.querySelector('.cpb-product-actions');
  
  if (innerWidth > 999) {
    panelsContainer.prepend(productDiscr);
    panelsContainer.prepend(productTitle);
  } else {
    previewAside.prepend(productTitle);
    productActions.append(productDiscr);
  }
}
const swipeViews = () => {

  const previewWrapper = document.querySelector('.cpb-preview-wrapper');
  const nextArrow = document.querySelector('.cpb-preview-arrows-item.cpb-preview-arrows-right');
  const prevArrow = document.querySelector('.cpb-preview-arrows-item.cpb-preview-arrows-left');
  
  previewWrapper.addEventListener('touchstart', handleTouchStart, false);        
  previewWrapper.addEventListener('touchmove', handleTouchMove, false);
  previewWrapper.closest('#product-builder').dataset.customSwipe = 'true';
  
  var xDown = null;                                                        
  var yDown = null;
  
  function getTouches(evt) {
    return evt.touches
  }                                                     
                                                                           
  function handleTouchStart(evt) {
      const firstTouch = getTouches(evt)[0];                                      
      xDown = firstTouch.clientX;                                      
      yDown = firstTouch.clientY;                                      
  };                                                
                                                                           
  function handleTouchMove(evt) {
      if ( ! xDown || ! yDown ) {
          return;
      }
  
      var xUp = evt.touches[0].clientX;                                    
      var yUp = evt.touches[0].clientY;
  
      var xDiff = xDown - xUp;
      var yDiff = yDown - yUp;
                                                                           
      if ( Math.abs( xDiff ) > Math.abs( yDiff ) ) {
          if ( xDiff > 0 ) {
              nextArrow.click();
          } else {
              prevArrow.click();     
          }                       
      }
      xDown = null;
      yDown = null;                                             
  };
}

const customCodeInit = () => {
  moveTitleAndDiscrOnMobile();
  addEventListener('resize', moveTitleAndDiscrOnMobile);

  swipeViews();
}


document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', customCodeInit);